import React from 'react';
import './MessagePanel.css';
import classNames from 'classnames';
import IconButton from '../button/IconButton';

type MessagePanelPropsType = {
    message: string;
    closeHandler: () => void;
    position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top-center' | 'bottom-center' | 'center';
    customPosition?: { top?: number, left?: number, right?: number, bottom?: number };
}

const MessagePanel: React.FC<MessagePanelPropsType> = ({ message, position, closeHandler }) => {

    return (
        <div className={ classNames('message-panel', position ? position : 'top-center' ) }>
            <div className='message-panel-inner'>
                <div className='btn-container'>
                    <IconButton icon='close' onClick={closeHandler} small/>
                </div>
                <p>{ message }</p>
            </div>
        </div>
    );
};

export default MessagePanel;
